export default "__VITE_ASSET__DPcxbCu8__"